import type {
  UserList,
  UsersListResponse,
} from '@app/application/user-management/types'

import SFetch from '@app/utils/sfetch'

export const fetchUsers = ({
  list,
  page = 1,
}: {
  list: UserList
  page?: number
}): Promise<UsersListResponse | null> => {
  const route =
    list === 'staff'
      ? window.Silverfin.Routes.staff_users_path
      : window.Silverfin.Routes.external_users_path

  return SFetch.json<UsersListResponse>(
    route(window.Silverfin.currentFirmId, { format: 'json', page })
  )
}
